import {
  AutonomousVehicleDocumentType,
  CarrierDocumentType,
  CaseSection,
  CertificateDataReviewSection,
  LicensingAgencyDocumentType,
  OpenAPI,
} from '@/@types/generated'

// Content URLs for inline preview / download from the API's `.../content`
// endpoints. Not from a generated service method: the generated client returns
// a parsed body, not a URL, so it can't back an <iframe src> or <a download>.
// Kept in one place, tied to OpenAPI.BASE, so the routes aren't duplicated.
const base = (): string => OpenAPI.BASE ?? ''

export const documentContentUrl = {
  application: (
    applicationId: string,
    documentType: CarrierDocumentType
  ): string =>
    `${base()}/api/Application/${applicationId}/uploads/${documentType}/content`,

  businessPartnerIdDocument: (
    applicationId: string,
    partnerId: string
  ): string =>
    `${base()}/api/Application/${applicationId}/partners/${partnerId}/id-document/content`,

  businessOfficerIdDocument: (
    applicationId: string,
    officerId: string
  ): string =>
    `${base()}/api/Application/${applicationId}/officers/${officerId}/id-document/content`,

  motorCarrier: (
    carrierId: string,
    documentType: CarrierDocumentType
  ): string =>
    `${base()}/api/MotorCarriers/${carrierId}/uploads/${documentType}/content`,

  truckStopInterstateTariff: (companyId: string): string =>
    `${base()}/api/TruckStop/companies/${companyId}/interstate-tariff-document/content`,

  autonomousVehicle: (
    registrationId: string,
    documentType: AutonomousVehicleDocumentType
  ): string =>
    `${base()}/api/AutonomousVehicleAuthority/registrations/${registrationId}/uploads/${documentType}/content`,

  licensingAgency: (
    agencyId: string,
    documentType: LicensingAgencyDocumentType
  ): string =>
    `${base()}/api/LicensingAgencies/${agencyId}/uploads/${documentType}/content`,

  caseAttachment: (
    caseId: number,
    section: CaseSection,
    name: string
  ): string =>
    `${base()}/api/Cases/${caseId}/attachments/${section}/content?name=${encodeURIComponent(name)}`,

  certificateDataReviewAttachment: (
    certificateDataReviewId: string,
    section: CertificateDataReviewSection,
    name: string
  ): string =>
    `${base()}/api/CertificateDataReview/${certificateDataReviewId}/attachments/${section}/content?name=${encodeURIComponent(name)}`,

  vehicleReviewRequestDocument: (
    requestId: string,
    documentId: string
  ): string =>
    `${base()}/api/vehicle-review-requests/${requestId}/documents/${documentId}/content`,

  carrierVehicleReviewRequestDocument: (
    carrierId: string,
    requestId: string,
    documentId: string
  ): string =>
    `${base()}/api/MotorCarriers/${carrierId}/vehicle-review-requests/${requestId}/documents/${documentId}/content`,
}
